<div [ngSwitch]="statistic.type">
  <app-door-statistic *ngSwitchCase="'door'" [statistic]="statistic"></app-door-statistic>
  <app-temperature-statistic *ngSwitchCase="'temperature'" [statistic]="statistic"></app-temperature-statistic>
</div>

